<template>
	<div class="login">

		<body class="account-page" style="font-family: 'Quicksand', sans-serif;
    font-size: .9375rem;
    color: #1f1f1f;
    background-color: #f7f7f7;
    min-height: 100%;
    overflow-x: hidden;">

			<!-- Main Wrapper -->
			<div class="main-wrapper">
				<div class="account-content" style="padding: 35px 0;">
					<div class="container">
						<!-- Account Logo -->
						<!-- /Account Logo -->

						<div class="account-box">
							<div class="account-wrapper">
								<div class="row">
									<div class="col-md-3">
										<div class="account-logo">
							<router-link to="/index"><img :src="logo" v-if="logo" alt="Sapphire HR"> <img src="../assets/logo.png" v-if="!logo" alt="Sapphire HR">
							</router-link>
						</div>
									</div>
									<div class="col-md-9">
										<h3 class="account-title">Login</h3>
										<p class="account-subtitle">Access to your portal</p>
									</div>
								
								</div>
								<div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="error">
									<strong>{{error}}</strong>
									<button type="button" class="close" data-dismiss="alert" aria-label="Close">
										<span aria-hidden="true">&times;</span>
									</button>
								</div>
								<!-- Account Form -->
								<form  @submit.prevent="onSubmit">
									<div class="form-group">
										<label>Email Address</label>
										<input class="form-control" type="text" v-model.trim="$v.username.$model" name="applicant email" :class="{ 'is-invalid': submitted && $v.username.$error }" />
                						<div v-if="submitted && !$v.username.required" class="invalid-feedback">applicant email is required</div>
									</div>
									<div class="form-group">
										<div class="row">
											<div class="col">
												<label>Password</label>
											</div>
											
										</div>
										<input type="password" v-model.trim="$v.password.$model" name="password" class="form-control" :class="{ 'is-invalid': submitted && $v.password.$error }" />
                						<div v-if="submitted && !$v.password.required" class="invalid-feedback">Password is required</div>
									</div>
									<div class="form-group text-center">
										<button class="btn btn-primary account-btn" :disabled="loading" type="submit">{{(!loading) ? 'Login to Career Portal': 'Loading..'}}</button>
									</div>
									<div class="account-footer">
									</div>
								</form>
								<!-- /Account Form -->

							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- /Main Wrapper -->
		</body>
	</div>
</template>

<script>
	import { required } from 'vuelidate/lib/validators';
	import { organizationService } from '@/services/organizationService';
	import { authenticationService } from '@/services/authenticationService';
	export default {
		name: 'applicant-login',
		data () {
        return {
            username: '',
            password: '',
            submitted: false,
            loading: false,
			logo: '',
            returnUrl: '',
            error: ''
        };
    },
    validations: {
      username: { required },
      password: { required }
    },
		methods: {
			getOrg() {
      		organizationService.getOrganization().then(
        		o=> { this.theme = o.theme; this.logo = o.logo }
      )
    },
        onSubmit () {
            this.submitted = true;

            // stop here if form is invalid
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }

            this.loading = true;
            authenticationService.applicantlogin(this.username, this.password)
                .then(
                    user => {
						if(user){
							localStorage.setItem('Id', user);
            				return this.$router.push('/applicantdetail/' + user);
						}else{
							this.error = "Email or Password are incorrect"
							this.loading = false
						}
					},
                    error => {
                        this.error = error;
                        this.loading = false;
                    }
                );
        }
    },
	mounted(){
	  this.getOrg()
  },
	}
</script>


// WEBPACK FOOTER //
// src/components/applicantLogin.vue